
import create from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import createKnowledgeEditorSlice from "./KnowledgeEditor/createKnowledgeEditorSlice";
import createAccountManagementSlice from "./slices/createAccountManagementSlice";
import createAppSlice from "./slices/createAppSlice";
import createBranchDeployerSlice from "./slices/createBranchDeployerSlice";
import createCollectionsSlice from "./slices/createCollectionsSlice";
import createConversationsSlice from "./slices/createConversationsSlice";
import createPreviewSlice from "./slices/createPreviewSlice";
import createTripletsSlice from "./slices/createTripletsSlice";
import createCampaignSlice from "./slices/createCampaignSlice";
import createNotificationsSlice from "./slices/createNotificationsSlice";

const devtoolsEnabled
  = import.meta.env.VITE_ENV && import.meta.env.VITE_ENV !== "production";
const useAppStore = create(
  devtools(
    subscribeWithSelector((...args) => ({
      ...createAppSlice(...args),
      ...createPreviewSlice(...args),
      ...createTripletsSlice(...args),
      ...createConversationsSlice(...args),
      ...createKnowledgeEditorSlice(...args),
      ...createCollectionsSlice(...args),
      ...createAccountManagementSlice(...args),
      ...createBranchDeployerSlice(...args),
      ...createCampaignSlice(...args),
      ...createNotificationsSlice(...args)
    })),
    { name: "appStore", enabled: devtoolsEnabled }
  )
);
export default useAppStore;
